<template>
  <v-container class="d-grid-center-align">
    <v-alert :type="alertType" v-model="showAlert">{{ message }}</v-alert>
    <v-card :loading="isLoading" class="mx-auto single-user-card rounded-lg" min-width="375">
      <v-btn class="single-user-card__button ma-2" exact :to="{ name: 'users' }" color="secondary" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text class="single-user-card__details">
        <p class="pa-2 black--text font-weight-normal">
          Contact Person: <span class="pa-2 font-weight-bold black--text">{{ user.contact_person }}</span>
        </p>
        <p class="pa-2 black--text font-weight-normal">
          Email: <span class="pa-2 font-weight-bold black--text">{{ user.email }}</span>
        </p>
        <p class="pa-2 black--text font-weight-normal">
          Type: <span class="pa-2 font-weight-bold black--text">{{ userRole }}</span>
        </p>
        <p class="pa-2 black--text font-weight-normal">
          Company: <span class="pa-2 font-weight-bold black--text">{{ user.company_name }}</span>
        </p>
        <p class="pa-2 black--text font-weight-normal">
          Location: <span class="pa-2 font-weight-bold black--text">{{ user.location }}</span>
        </p>
      </v-card-text>
      <p v-if="frozenPrice" class="red--text text-center ">{{ user.company_name }} price is frozen</p>
      <p v-if="frozenPrice" class="red--text text-center ">{{ user.fixed_metals_prices }}</p>
      <v-card-actions class="single-user-card__actions">
        <v-row class="ma-2">
          <v-col class="pa-0 mx-1">
            <v-btn
              min-width="100%"
              :to="{ name: 'user-edit', params: { id: user.id } }"
              class="white--text ma-0 pa-2"
              color="#2E3030"
            >
              edit profile</v-btn
            >
          </v-col>
        </v-row>
        <v-row class="ma-2">
          <v-col class="pa-0 mx-1">
            <v-btn
              :to="{ name: 'user-logs', params: { id: user.id } }"
              block
              color="accent darken-2"
              class="white--text ma-0 pa-2"
              >Location logs</v-btn
            >
          </v-col>
          <v-col class="pa-0 mx-1">
            <v-btn
              block
              @click="createCheckInSheetForUser"
              color="accent darken-2"
              class="white--text ma-0 pa-2"
            >
              New Check-in Sheet</v-btn
            >
          </v-col>
        </v-row>
        <v-row class="ma-2">
          <v-col class="pa-0 mx-1">
            <v-btn
              block
              @click="toggleFrozenUserPrice"
              color="accent darken-2"
              class="white--text ma-0 pa-2"
            >
              {{ frozenPrice ? "Un-freeze price" : "Freeze Price" }}
            </v-btn>
          </v-col>
          <v-col class="pa-0 mx-1">
            <v-btn
              block
              @click="$router.push({ name: 'change-user-password', params: { user_id: user.id } })"
              color="accent darken-2"
              class="white--text ma-0 pa-2"
            >
              Change Password
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import { roles } from "@/constants";
import { mapGetters as preciousMetalsGetters } from "@/store/modules/preciousMetals";
export default {
  name: "User",
  async created() {
    try {
      const userId = this.$route.params.id;
      this.isLoading = true;
      this.user = extractDataAxios(await window.axios.get("/api/users/" + userId));
    } catch (e) {
      this.displayAlert("error", extractErrorMessageAxios(e))
    } finally {
      this.isLoading = false;
    }
  },
  data() {
    return {
      user: {},
      isLoading: false,
      showAlert: false,
      message: "",
      alertType: null
    };
  },
  computed: {
    userRole() {
      const role = roles.filter((role) => role.value === this.user.role)[0];
      return role && role.text;
    },
    frozenPrice() {
      return !!this.user.fixed_metals_prices;
    },
    ...preciousMetalsGetters(["pricesArray"]),
  },
  methods: {
    async toggleFrozenUserPrice() {
      let fixedPrice = null;
      this.isLoading = true;
      if (!this.frozenPrice) {
        fixedPrice = Object.assign({}, this.createFixedPriceObject());
      }
      const response = await window.axios.put(`/api/user/${this.user.id}/update/frozen-price`, fixedPrice);
      this.user = extractDataAxios(response);
      this.isLoading = false;
    },
    async createCheckInSheetForUser() {
      try {
        // send an axios requrest to create a check in sheet. THen route to that check in sheet.
        const response = await window.axios.post("/api/check-in-sheet", {
          company_name: this.user.company_name,
        });
        const checkInSheet = extractDataAxios(response);
        this.$router.push({ name: "single-check-in-sheet", params: { id: checkInSheet.id } });
      } catch (e) {
        this.displayAlert("error", extractErrorMessageAxios(e))
      }
    },
    createFixedPriceObject() {
      return { platinum: this.pricesArray[0], palladium: this.pricesArray[1], rhodium: this.pricesArray[2] };
    },
    displayAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
    }
  },
};
</script>

<style scoped>
.single-user-card {
  margin: auto;
}
.single-user-card__button {
  position: absolute;
  right: 0;
}
.single-user-card__actions {
  display: grid;
  grid-template-areas:
    "button1 button1"
    "button2 button3"
    "button4";
  margin: 4px;
}
.single-user-card__details {
  display: grid;
}
</style>
